export const environment = {
  production: true,
  staging: false,
  hmr: false,
  SENTRY_ENABLED: false,
  SENTRY_DSN: '',
}

export const SERVER_URL = 'https://ukaz-backend.aspik.is'
export const ORGANIZATION_TITLE = 'ASPIK'
export const ORGANIZATION_SUBTITLE = 'Ukázka'
